import { FirestoreDataConverter } from "firebase/firestore";
import { omitBy } from "lodash";
import moment from "moment";
import Update from "../models/update";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class UpdateDb extends BaseDb<Update, { updateId: string }> {
  _path: string = "updates/updateId";
  getConverter(): FirestoreDataConverter<Update> {
    return {
      fromFirestore: (snapshot) =>
        new Update({
          id: snapshot.id,
          perfil: snapshot.get("perfil"),
          mensagem: snapshot.get("mensagem"),
          dataUpdate: moment(snapshot.get("dataUpdate").toDate()),
        }),
      toFirestore: (update: Update) => toFirestore(omitBy(update, ["id"])),
    };
  }
}
